export default __webpack_public_path__ + "42aaa181adb3af3bef08749a4d81aa66.gif";